import { render, staticRenderFns } from "./EducationalRatingInfo.vue?vue&type=template&id=07dfee18&"
import script from "./EducationalRatingInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports